var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgCheckbox = function SvgCheckbox(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 20 20"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#5a61dc",
    d: "M3.85 0h12.3c1.34 0 1.83.14 2.32.4.48.26.87.65 1.13 1.13.26.5.4.98.4 2.32v12.3c0 1.34-.14 1.83-.4 2.32-.26.48-.65.87-1.13 1.13-.5.26-.98.4-2.32.4H3.85c-1.34 0-1.83-.14-2.32-.4A2.73 2.73 0 0 1 .4 18.47c-.26-.5-.4-.98-.4-2.32V3.85C0 2.5.14 2.02.4 1.53.66 1.05 1.05.66 1.53.4c.5-.26.98-.4 2.32-.4"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "m17.64 6.5-9.3 9.3a1.23 1.23 0 0 1-1.73 0l-4.25-4.25A1.23 1.23 0 1 1 4.1 9.8l3.38 3.38 8.42-8.43a1.23 1.23 0 1 1 1.74 1.74z"
  }))));
};
export default SvgCheckbox;